<script setup>
import UserBioPanel from '@/views/apps/user/view/UserBioPanel.vue'
import UserTabAccount from '@/views/apps/user/view/UserTabAccount.vue'
import UserTabBillingsPlans from '@/views/apps/user/view/UserTabBillingsPlans.vue'
import UserTabConnections from '@/views/apps/user/view/UserTabConnections.vue'
import UserTabNotifications from '@/views/apps/user/view/UserTabNotifications.vue'
import UserTabSecurity from '@/views/apps/user/view/UserTabSecurity.vue'
import { useUserStatusStore } from '@/composables/useGlobalStore'

const route = useRoute('apps-user-view-id')
const userTab = ref(null)
const userStatusStore=useUserStatusStore()
const { data: userData } = await useApi(`/apps/users/${route.params.id}`)
const user=computed(()=> userStatusStore.mapStatusToUser(userData.value))

definePage({
  meta: {
    action: 'read',
    subject: 'users',
  },
})
</script>

<template>
  <VRow v-if="user">
    <VCol cols="12" md="5" lg="4">
      <UserBioPanel :user-data="user" />
    </VCol>

    <VCol cols="12" md="7" lg="8">
      <VTabs v-model="userTab" class="v-tabs-pill">
        <VTab v-for="tab in [
          {
            icon: 'tabler-users',
            title: $t('Account'),
          },
          {
            icon: 'tabler-lock',
            title: $t('Security'),
          },
          {
            icon: 'tabler-bookmark',
            title: 'Billing & Plan',
          },
          {
            icon: 'tabler-bell',
            title: $t('Notifications'),
          },
          {
            icon: 'tabler-link',
            title: 'Connections',
          },
        ]" :key="tab.icon">
          <VIcon :size="18" :icon="tab.icon" class="me-1" />
          <span>{{ tab.title }}</span>
        </VTab>
      </VTabs>

      <VWindow v-model="userTab" class="mt-6 disable-tab-transition" :touch="false">
        <VWindowItem>
          <UserTabAccount />
        </VWindowItem>

        <VWindowItem>
          <UserTabSecurity />
        </VWindowItem>

        <VWindowItem>
          <UserTabBillingsPlans />
        </VWindowItem>

        <VWindowItem>
          <UserTabNotifications />
        </VWindowItem>

        <VWindowItem>
          <UserTabConnections />
        </VWindowItem>
      </VWindow>
    </VCol>
  </VRow>
  <div v-else>
    <VAlert type="error" variant="tonal">
      Invoice with ID {{ route.params.id }} not found!
    </VAlert>
  </div>
</template>
